import React, { useState } from 'react';
import { TextField, Button, Typography,Link } from '@material-ui/core';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import Divider from '@material-ui/core/Divider';
import SettingsIcon from '@material-ui/icons/Settings';
import copy from 'copy-to-clipboard';
import { toast } from 'react-toastify';

const SnapboardLinkPage = ({ link }) => {
    const [textAreaValue,setTextAreaValue] = useState(` Hi. \n Please display the link below on our TV monitors in the (lobby) area.\n \n Snapboard link:\n ${link} \n \n For more info, please visit https://snapfix.net/snapboard \n Thank you.`)

    return (
        <div className="link-page-container">
            <div className="link-page-content">
                <h1>THANK YOU!</h1>
                <p>YOUR SNAPBOARD LINK IS:</p>

                <TextField
                    id="outlined-basic"
                    variant="outlined"
                    value={link}
                    className="url-textfield"
                    size="small"
                />
                <div className="button-link-container">

                    <Link href={`${link}`} target="_blank" rel="noopener" className="preview-button" style={{color:"white"}}>
                        Click To Preview <ArrowRightIcon style={{ color: 'white' }} />
                    </Link>
                    <Button
                        variant="contained"
                        className="copy-to-clip"
                        endIcon={<FileCopyOutlinedIcon />}
                        onClick={()=>{
                            copy(link)
                            toast.success("Snapboard link is copied to Clipboard")
                        }}
                    >
                        COPY LINK TO CLIPBOARD
                    </Button>
                </div>

                <div className="divider-container">
                    <span> <SettingsIcon /> INSTALLING</span>
                   
                    <Divider variant='middle'/>
                </div>

                <Typography variant="subtitle1" component="h2" className="info-text">
                    To send instructions to your Audio-Visual person, just copy and paste the following into an email to them.
                    <br/>
                    Edit as required!
                </Typography>

                <TextField
                    id="outlined-multiline-static"
                    multiline
                    rowsMax={10}
                    className="url-about-content"
                    defaultValue={textAreaValue}
                    variant="outlined"
                    onChange={(e) => setTextAreaValue(e.currentTarget.value)}
                />
                <Button
                    variant="contained"
                    className="copy-to-clip"
                    endIcon={<FileCopyOutlinedIcon />}
                    onClick={()=>{
                        copy(textAreaValue)
                        toast.success("Text is copied to Clipboard")
                    }                     
                    }
                >
                    COPY TEXT TO CLIPBOARD
                </Button>
                <div className="need-help">
                    <span> <SettingsIcon /> Need Help?</span>
                    <Divider variant='middle'/>
                    <p>
                        Just email us at <span>info@snapfix.net</span>
                    </p>
                </div>
            </div>

        </div>
    )
};
export default SnapboardLinkPage;